import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { bucketApi, RenameModelPhotoByPathInput } from '~/supabase/bucket/api'

export const useRenameModelPhoto = () => {
  return useMutation({
    mutationKey: ['rename-model-photo'],
    mutationFn: (payload: RenameModelPhotoByPathInput[]) =>
      payload.reduce(
        async (chain, item) => {
          const results = await chain
          const result = await bucketApi.renameModelPhotoByPath(item)
          return [...results, result]
        },
        Promise.resolve([] as Awaited<ReturnType<typeof bucketApi.renameModelPhotoByPath>>[])
      ),
    onError: (error: Error) => {
      toast.error(error.message)
    },
  })
}
